export const ObjectNames = {
    //Constants for Product Inventory
    productConstants: {
        ProductName: 'Product',
        LineLevelDiscountCategoryId: 1,
        ProductGroupName: 'Product Group',
        ProductColorName: 'Product Color',
        TrackingSettingName: 'allowtracking',
        ProductTypeName: 'ProductType',
        ProductCategoryName: 'Product Category',
        ProductVisibilityName: 'Product Visibility',
        UOMPropertyName: 'UnitOfMeasure',
        categoryWeightPropertyName: 'Weight',
        categoryHeightPropertyName: 'Length',
        AddNewConstant: 'Add New',
        filters: [
            { label: "All Products", code: 'allproducts' },
            { label: "My Products", code: 'myproducts' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedproducts' }
        ],
        taxList: [
            { "name": "Yes", "value": true },
            { "name": "No", "value": false }
        ],
        titlewarrantyFieldName: 'Warranty',
        DiscountGroupType: "Discount By Product Group",
        DiscountQtyType: "Discount By Qty"
    },

    warehouseConstants: {
        filters: [
            { label: "All Locations", code: 'allwarehouses' },
            { label: "My Locations", code: 'mywarehouses' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedwarehouses' }
        ],
        locationTypes: [
            { id: 1, name: "Location" , objectName : 'Warehouse'},
            { id: 2, name: "Inventory Transfer" , objectName : 'InventoryTransfer'},
            { id: 3, name: "Inventory Adjustment" , objectName : 'InventoryAdjustment' }
        ],
        //location
        AddLocationTitle: 'Add Location',
        EditLocationTitle: 'Edit Location',
        categoryGroupName: 'WarehouseCategory',
        typeGroupName: 'WarehouseType',
        groupName: 'WarehouseGroup',
        AddGroupTitle: 'Add New Group',
        ModuleName: 'Warehouse',
        LocationName: 'Location',

        //Bin
        AddBinTitle: 'Add Bin Detail',
        EditBinTitle: 'Edit Bin Detail',
        EditAction: 'edit',
        DeleteAction: 'delete',
        BinTypeName: 'BinType',
        BinTypeOption: ['Manual', 'Wizard'],
        separators: [{ id: 1, name: ':' }, { id: 2, name: '-' }],
        wizard: [
            { id: 1, level: "Aisle", code: "aisle", description: "Number of aisles within each section.", prefix: "", number: 0, },
            { id: 2, level: "Racks", code: "racks", description: "Number of racks in each aisle.", prefix: "", number: 0, },
            { id: 3, level: "Levels", code: "levels", description: "Number of levels in each rack.", prefix: "", number: 0, },
            { id: 4, level: "Bins", code: "bins", description: "Number of bins/positions at each level.", prefix: "", number: 0, },
        ],


    },
    purchaseConstants: {
        Purchase_Template_Object: "Purchase Template",
        Purchase_Section_Object: "Purchase Section",
        Purchase_Module_Object: "Purchases",
        purchaseOrderfilters: [
            { label: "All Purchase Order", code: 'allpurchaseorders' },
            { label: "My Purchase Order", code: 'mypurchaseorders' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedpurchases' }
        ],
    },
    vendorConstants: {
        vendorfilters: [
            { label: "All Vendors", code: 'allvendors' },
            { label: "My Vendors", code: 'myvendors' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedvendors' }
        ],
        transactionTypes: [
            { label: "All", code: 0 },
            { label: "Purchase Order", code: 17},
            { label: "Item Receipt", code: 4 },
            { label: "Bill", code: 6 },
            { label: "Payment Receipt", code: 5 }
        ]
    },
    vendorRenurnConstants: {
        vendorRenurn_Module_Object: "VendorReturns",
        vendorReturnfilters: [
            { label: "All Vendor Returns", code: 'allvendorreturns' },
            { label: "My Vendor Returns", code: 'myvendorreturns' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedvendorreturns' }
        ],
        transactionTypes: [
            { label: "All", code: 0 },
            { label: "Purchase Order", code: 17},
            { label: "Item Receipt", code: 4 },
            { label: "Bill", code: 6 },
            { label: "Payment Receipt", code: 5 }
        ]
    },
    vendorCreditFilterConstants: {
        vendorCreditfilters: [
            { label: "All Vendor Credits", code: 'allvendorcredits' },
            { label: "My Vendor Credits", code: 'myvendorcredits' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedvendorcredits' }
        ],
    },
    billConstants: {
        billPaymentChannelId: 4,
        billfilters: [
            { label: "All Payment Receipts", code: 'allbillpayments' },
            { label: "My Payment Receipts", code: 'mybillpayments' },
            { label: "New last week", code: 'newlastweek' },
            { label: "New this week", code: 'newthisweek' },
            { label: "New this month", code: 'newthismonth' },
            { label: "Recently Viewed", code: 'recentlyviewedbillpayments' }
        ],
        billTypes: [
            { id: 1, name: "Create bill" },
            { id: 2, name: "Pay bills" }
        ],
        Bill_Module_Object: "BillPayment",
    },
    newBillConstants: {
        billfilters: [
            { label: "All Bills", code: 'allbill' },
            { label: "Open Bills", code: 'openbill' },
            { label: "Overdue Bills", code: 'overduebill' },
        ],
        journalEntryTxnType: 8
    },
    receivedItemsConstants: {
        receivedItemsfilters: [ { label: "All Item Receipts", code: 'allrpo' },
        { label: "My Item Receipts", code: 'myrpo' },
        { label: "New last week", code: 'newlastweek' },
        { label: "New this week", code: 'newthisweek' },
        { label: "New this month", code: 'newthismonth' },
        { label: "Recently Viewed", code: 'recentlyviewedrpos' }
    ],
    poTableCols : [
        { id: 1, header: 'PO No.', field: 'poNo', show: true },
        { id: 2, header: 'PO Date', field: 'poDate', show: true },
        { id: 3, header: 'PO Amount', field: 'amount', show: true }
      ]
    },
    newBillsConstants: {
        newBillsfilters: [ { label: "All Bills", code: 'allbill' },
        { label: "Open Bills", code: 'openbill' },
        { label: "Overdue Bills", code: 'overduebill' }
    ],
    }
}

export enum Severity {
    Success = 'success',
    Error = 'error',
    Warn = 'warn',
    Info = 'info'
}

export enum Status {
    Active = 1,
    InActive = 2,
    Deleted = 3
}

export enum EstimateStatus {
    Open = 1,
    Processing = 2,
    PartiallyFilled = 3,
    Completed = 4,
    Hold = 5,
    Void = 6,
}

export enum EstimateNewStatus {
    Draft = 0,
    NeedsReview = 1,
    InReview = 2,
    Approved = 3,
    Rejected = 4,
    Presented = 5,
    Accepted = 6,
    Denied = 7,
    Void = 8,
}

export enum SalesOrderStatus {
    Void = 2,
    Hold = 3
}

export enum InvoiceStatus {
    Processing = 1,
    Completed = 2,
    Hold = 3,
    Void = 4,
    Cancel = 5
}

export const VENDOR_OBJ_ID = 99;


export enum FieldDataType {
    Number = "Number",
    String = "String",
    Currency = "Currency",
    DateTime = "DateTime",
}

export enum VendorBillStatus {
    Pending = 0,
    Partial = 1,
    Full = 2,
    Voided = 3,
    Created = 4,
}

export enum PurchaseOrderStatusEnums {
    Open = 1,
    Processing = 2,
    PartiallyFilled = 3,
    Completed = 4,
    Hold = 5,
    Void = 6,
}

export enum VendorRMAStatusEnums
 {
    Initiation = 1,
    Sent = 2,
    Approved = 3,
    Declined = 4,
    Void = 5,

}

export enum VendorCreditStatusEnums
 {
    Open = 1,
    Applied = 2,
    PartiallyApplied = 3,
    Void = 4,
    Paid = 5,

}

export enum VendorTransactionStageEnums
 {
    Entered = 1,
    Issued = 2,
    ReceiveInventory = 3,
    Closed = 4,
}


export enum VendorBillPaymentStatusEnums
 {
    Paid = 1,
    Voided = 3,
}

export enum VendorPaymentReceiptsStatusEnums
 {
    Open = 1,
    PartiallyPaid = 2,
}


export enum ProductTransactionStatusEnums
 {
    Bill = 1,
    CreditCharges = 2,
    VendorCredit=3,
    CustomerRMA=4,
    Check=5,
    Invoice = 6,
    CreditMemo = 7,
    InventoryAdjustment=8,
    VendorRMA=9,
    Expense=10,
    InventoryTransfer=11,
    ItemReceipt=12
}

export enum ProductTransactionActionEnums
 {
    Update = 1,
    Add = 2,
    Create=3,
    Delete=4,
}

export enum ProductTransactionIsActiveEnums
 {
    Yes = 1,
    No = 2,
 }


 export enum BillStatusEnums
 {
    Created = 1,
    Voided = 2,
 }

 export enum BillPaymentStatusEnums
 {
    Open = 1,
    Paid = 2,
    PartiallyPaid = 3,
 }

 
 export enum AgingStatusEnums {
    Current = 1,
    Days31to60 = 2,
    Days61to90 = 3,
    Days91plus = 4
  }
  





